export const homeHeadlineClass =
  "font-[family-name:var(--font-heading)]";
